import React, { useState, useEffect, useMemo } from 'react';
import Grid from '@mui/material/Grid2';
import { useDispatch, useSelector } from 'react-redux';
import HeaderComponent from '../components/HeaderComponent';
import { Box, Card, CardContent, Typography, Paper, Tooltip, IconButton } from '@mui/material';
import { getAccountManagerList, getDashboardMoMTrendsData, getDashboardAppSummaryData, getDashboardManagerSummaryData, getDashboardSummaryData, setActiveManager, setDashboardTimePeriod, getDashboardMonthlyTrendsData, getDashboardPendingDetailsCandidatesData } from '../redux/actions/commonActions';
import { setEmployerFilters } from '../redux/actions/employerActions';
import { useNavigate } from 'react-router-dom';
import { setJobsFilters } from '../redux/actions/jobActions';
import { Assignment, Badge, Call, Cancel, Checklist, CurrencyExchange, DescriptionOutlined, Flag, HourglassTop, Info, Person, Repeat, ThumbUp, Timeline, Work } from '@mui/icons-material';
import TimePeriodSelector from '../components/TimePeriodSelector';
import SummaryCard from '../components/SummaryCard';
import { cardColors } from '../helpers/dashboardColors';
import GoalModal from '../models/GoalModal';
import StickyNotesComponent from '../components/StickyNotesComponent';
import { setCandidateFilters } from '../redux/actions/candidateActions';
import PendingJoiningDetails from '../components/PendingJoiningDetails';
import MonthlyTrendsChart from '../components/MonthlyTrendsChart';
import LightTooltip from '../components/LightTooltip';

const ViewDashboard = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isGoalModalVisible, setIsGoalModalVisible] = useState(false);

  const dashboardTimePeriod = useSelector((state) => state.common.dashboardTimePeriod);

  const dashboardSummaryData = useSelector((state) => state.common.dashboardSummaryData);
  const dashboardAppSummaryData = useSelector((state) => state.common.dashboardAppSummaryData);
  const dashboardManagerSummaryData = useSelector((state) => state.common.dashboardManagerSummaryData);
  const accountManagers = useSelector((state) => state.common.accountManagers);
  const dashboardMonthlyTrendsData = useSelector((state) => state.common.dashboardMonthlyTrendsData);
  const dashboardPendingDetailsCandidates = useSelector((state) => state.common.dashboardPendingDetailsCandidates);

  const employerFilters = useSelector((state) => state.employer.employerFilters);
  const candidateFilters = useSelector((state) => state.candidate.candidateFilters);
  const jobsFilters = useSelector((state) => state.job.jobsFilters);

  const mainStyle = {
    divStyle: {
      display: 'flex',
      justifyContent: 'flex-start',
      padding: '4px'
    },
    spanStyle: {
      color: 'gray',
      textAlign: 'right',
      marginRight: '8px',
      minWidth: '140px',
      // width: '100px',
      fontSize: '14px'
    }
  };

  useEffect(() => {
    dispatch(getDashboardMonthlyTrendsData());
    dispatch(getDashboardPendingDetailsCandidatesData());
  }, []);

  useEffect(() => {
    dispatch(getDashboardSummaryData(dashboardTimePeriod));
    dispatch(getDashboardManagerSummaryData(dashboardTimePeriod));
    dispatch(getAccountManagerList(dashboardTimePeriod));
    dispatch(getDashboardAppSummaryData(dashboardTimePeriod));
  }, [dashboardTimePeriod]);

  const handleOverviewEmployersClick = () => {
    let empFilters = { ...employerFilters };

    empFilters['refundAccount'] = '';
    empFilters['zeroLineupClient'] = '';
    empFilters['managerId'] = '';

    empFilters['activeClient'] = true;
    empFilters['isApplied'] = true;
    dispatch(setEmployerFilters(empFilters));
    navigate(`/app/employers`);
  }

  const handleOverviewCandidatesClick = () => {
    let canFilters = { ...candidateFilters };
    canFilters['fromCreateDate'] = dashboardTimePeriod.fromDate;
    canFilters['toCreateDate'] = dashboardTimePeriod.toDate;
    canFilters['isApplied'] = true;
    dispatch(setCandidateFilters(canFilters));
    navigate(`/app/candidates`);
  }

  const handleOverviewJobsClick = () => {
    let jFilters = { ...jobsFilters };

    jFilters['highAgeingJob'] = '';
    jFilters['replacementDue'] = '';
    jFilters['inPipeline'] = '';
    jFilters['inProcess'] = '';
    jFilters['interviewed'] = '';
    jFilters['joined'] = '';
    jFilters['replaced'] = '';
    jFilters['managerId'] = '';
    jFilters['fromStatusDate'] = '';
    jFilters['toStatusDate'] = '';

    jFilters['trackerView'] = true;
    jFilters['active'] = true;
    jFilters['jobExpired'] = false;
    jFilters['isApplied'] = true;
    dispatch(setJobsFilters(jFilters));
    navigate(`/app/jobs`);
  }

  const handleOverviewInPipelineClick = () => {
    let jFilters = { ...jobsFilters };

    jFilters['highAgeingJob'] = '';
    jFilters['jobExpired'] = '';
    jFilters['active'] = '';
    jFilters['replacementDue'] = '';
    jFilters['inProcess'] = '';
    jFilters['interviewed'] = '';
    jFilters['managerId'] = '';

    jFilters['inPipeline'] = true;
    jFilters['fromStatusDate'] = dashboardTimePeriod.fromDate;
    jFilters['toStatusDate'] = dashboardTimePeriod.toDate;
    jFilters['trackerView'] = true;
    jFilters['isApplied'] = true;
    dispatch(setJobsFilters(jFilters));
    navigate(`/app/jobs`);
  }

  const handleOverviewInProcessClick = () => {
    let jFilters = { ...jobsFilters };

    jFilters['highAgeingJob'] = '';
    jFilters['jobExpired'] = '';
    jFilters['active'] = '';
    jFilters['replacementDue'] = '';
    jFilters['inPipeline'] = '';
    jFilters['interviewed'] = '';
    jFilters['managerId'] = '';

    jFilters['inProcess'] = true;
    jFilters['fromStatusDate'] = dashboardTimePeriod.fromDate;
    jFilters['toStatusDate'] = dashboardTimePeriod.toDate;
    jFilters['trackerView'] = true;
    jFilters['isApplied'] = true;
    dispatch(setJobsFilters(jFilters));
    navigate(`/app/jobs`);
  }

  const handleOverviewInterviewedClick = () => {
    let jFilters = { ...jobsFilters };

    jFilters['highAgeingJob'] = '';
    jFilters['jobExpired'] = '';
    jFilters['active'] = '';
    jFilters['replacementDue'] = '';
    jFilters['inPipeline'] = '';
    jFilters['inProcess'] = '';
    jFilters['managerId'] = '';

    jFilters['interviewed'] = true;
    jFilters['fromStatusDate'] = dashboardTimePeriod.fromDate;
    jFilters['toStatusDate'] = dashboardTimePeriod.toDate;
    jFilters['trackerView'] = true;
    jFilters['isApplied'] = true;
    dispatch(setJobsFilters(jFilters));
    navigate(`/app/jobs`);
  }

  const handleOverviewJoinedClick = () => {
    let jFilters = { ...jobsFilters };

    jFilters['highAgeingJob'] = '';
    jFilters['jobExpired'] = '';
    jFilters['active'] = '';
    jFilters['replacementDue'] = '';
    jFilters['inPipeline'] = '';
    jFilters['inProcess'] = '';
    jFilters['interviewed'] = '';
    jFilters['managerId'] = '';

    jFilters['joined'] = true;
    jFilters['fromStatusDate'] = dashboardTimePeriod.fromDate;
    jFilters['toStatusDate'] = dashboardTimePeriod.toDate;
    jFilters['trackerView'] = true;
    jFilters['isApplied'] = true;
    dispatch(setJobsFilters(jFilters));
    navigate(`/app/jobs`);
  }

  const handleOverviewReplacedClick = (e) => {
    e.stopPropagation();
    let jFilters = { ...jobsFilters };

    jFilters['highAgeingJob'] = '';
    jFilters['jobExpired'] = '';
    jFilters['active'] = '';
    jFilters['replacementDue'] = '';
    jFilters['inPipeline'] = '';
    jFilters['inProcess'] = '';
    jFilters['interviewed'] = '';
    jFilters['joined'] = '';
    jFilters['managerId'] = '';

    jFilters['replaced'] = true;
    jFilters['fromStatusDate'] = dashboardTimePeriod.fromDate;
    jFilters['toStatusDate'] = dashboardTimePeriod.toDate;
    jFilters['trackerView'] = true;
    jFilters['isApplied'] = true;
    dispatch(setJobsFilters(jFilters));
    navigate(`/app/jobs`);
  }

  const handleEmployersClick = (manager) => {
    let empFilters = { ...employerFilters };

    empFilters['refundAccount'] = '';
    empFilters['zeroLineupClient'] = '';

    empFilters['managerId'] = manager.adminUserId;
    empFilters['activeClient'] = true;
    empFilters['isApplied'] = true;
    dispatch(setEmployerFilters(empFilters));
    navigate(`/app/employers`);
  }

  const handleZeroLineupClientClick = (manager) => {
    let empFilters = { ...employerFilters };

    empFilters['refundAccount'] = '';
    empFilters['activeClient'] = '';

    empFilters['zeroLineupClient'] = true;
    empFilters['managerId'] = manager.adminUserId;
    empFilters['isApplied'] = true;
    dispatch(setEmployerFilters(empFilters));
    navigate(`/app/employers`);
  }

  const handleJobPostsClick = (manager) => {
    let jFilters = { ...jobsFilters };

    jFilters['highAgeingJob'] = '';
    jFilters['replacementDue'] = '';
    jFilters['inPipeline'] = '';
    jFilters['inProcess'] = '';
    jFilters['interviewed'] = '';
    jFilters['joined'] = '';
    jFilters['replaced'] = '';
    jFilters['fromStatusDate'] = '';
    jFilters['toStatusDate'] = '';

    jFilters['managerId'] = manager.adminUserId;
    jFilters['trackerView'] = true;
    jFilters['active'] = true;
    jFilters['jobExpired'] = false;
    jFilters['isApplied'] = true;
    dispatch(setJobsFilters(jFilters));
    navigate(`/app/jobs`);
  }

  const handleJoinedClick = (manager) => {
    let jFilters = { ...jobsFilters };

    jFilters['highAgeingJob'] = '';
    jFilters['jobExpired'] = '';
    jFilters['active'] = '';
    jFilters['replacementDue'] = '';
    jFilters['inPipeline'] = '';
    jFilters['inProcess'] = '';
    jFilters['interviewed'] = '';
    jFilters['replaced'] = '';

    jFilters['joined'] = true;
    jFilters['fromStatusDate'] = dashboardTimePeriod.fromDate;
    jFilters['toStatusDate'] = dashboardTimePeriod.toDate;
    jFilters['trackerView'] = true;
    jFilters['managerId'] = manager.adminUserId;
    jFilters['isApplied'] = true;
    dispatch(setJobsFilters(jFilters));
    navigate(`/app/jobs`);
  }

  const handleHighAgeingJobPostsClick = (manager) => {
    let jFilters = { ...jobsFilters };

    jFilters['replacementDue'] = '';
    jFilters['inPipeline'] = '';
    jFilters['inProcess'] = '';
    jFilters['interviewed'] = '';
    jFilters['joined'] = '';
    jFilters['replaced'] = '';
    jFilters['fromStatusDate'] = '';
    jFilters['toStatusDate'] = '';

    jFilters['highAgeingJob'] = true;
    jFilters['active'] = true;
    jFilters['jobExpired'] = false;
    jFilters['managerId'] = manager.adminUserId;
    jFilters['isApplied'] = true;
    dispatch(setJobsFilters(jFilters));
    navigate(`/app/jobs`);
  }

  const handleRefundAccountsClick = () => {
    let empFilters = { ...employerFilters };

    empFilters['activeClient'] = '';
    empFilters['zeroLineupClient'] = '';

    empFilters['refundAccount'] = true;
    empFilters['isApplied'] = true;
    dispatch(setEmployerFilters(empFilters));
    navigate(`/app/employers`);
  }

  const handleReplacementDuesClick = (manager) => {
    let jFilters = { ...jobsFilters };

    jFilters['highAgeingJob'] = '';
    jFilters['jobExpired'] = '';
    jFilters['inPipeline'] = '';
    jFilters['inProcess'] = '';
    jFilters['interviewed'] = '';
    jFilters['joined'] = '';
    jFilters['replaced'] = '';
    jFilters['fromStatusDate'] = '';
    jFilters['toStatusDate'] = '';

    jFilters['replacementDue'] = true;
    jFilters['active'] = true;
    jFilters['managerId'] = manager.adminUserId;
    jFilters['isApplied'] = true;
    dispatch(setJobsFilters(jFilters));
    navigate(`/app/jobs`);
  }

  const handleNavigateToManagerDashboard = (manager) => {
    let aManager = {
      'name': manager.name,
      'adminUserId': manager.adminUserId
    }
    dispatch(setActiveManager(aManager));
    navigate(`/app/dashboard/${manager.adminUserId}`)
  }

  const handleTimePeriodChange = (e) => {
    let aParams = {
      'rangeType': e.rangeType,
      "fromDate": e.from,
      "toDate": e.to
    }

    dispatch(setDashboardTimePeriod(aParams));
  }

  const handleGoalsClick = () => {
    setIsGoalModalVisible(true);
  }

  const handleCloseGoalModal = () => {
    setIsGoalModalVisible(false);
  }

  const goalProgressRounded = Math.round((dashboardSummaryData?.goalAchievedValue * 100) / dashboardSummaryData?.goalValue);

  const overviewCardsData = [
    {
      title: "Active Employers",
      value: dashboardSummaryData?.totalActiveEmployers,
      secondValue: `App: ${dashboardSummaryData?.totalActiveAppEmployers}`,
      thirdValue: `Assisted: ${dashboardSummaryData?.totalActiveAssistedHireEmployers}`,
      onClick: handleOverviewEmployersClick,
      icon: <Badge />
    },
    {
      title: "Active Jobs",
      value: dashboardSummaryData?.totalActiveJobPostsOverall,
      secondValue: `App: ${dashboardSummaryData?.totalActiveAppJobPostsOverall}`,
      thirdValue: `Assisted: ${dashboardSummaryData?.totalActiveAssistedHireJobPostsOverall}`,
      // trendPercentage: dashboardSummaryData?.jobPostsTrendRate,
      onClick: handleOverviewJobsClick,
      icon: <Work />
    },
    {
      title: "Candidates",
      value: dashboardSummaryData?.totalCandidates,
      secondValue: `App: ${dashboardSummaryData?.totalAppCandidates}`,
      thirdValue: `Non App: ${dashboardSummaryData?.totalNonAppCandidates}`,
      onClick: handleOverviewCandidatesClick,
      icon: <Person />
    },
    {
      title: "In Pipeline",
      value: dashboardSummaryData?.totalInPipeline,
      onClick: handleOverviewInPipelineClick,
      icon: <Timeline />
    },
    {
      title: "In Process",
      value: dashboardSummaryData?.totalInProcess,
      onClick: handleOverviewInProcessClick,
      icon: <HourglassTop />
    },
    {
      title: "Interviews",
      value: dashboardSummaryData?.totalInterviews,
      trendPercentage: dashboardSummaryData?.interviewedTrendRate,
      onClick: handleOverviewInterviewedClick,
      icon: <Call />
    },
    {
      title: "Joined",
      value: dashboardSummaryData?.totalJoined,
      trendPercentage: dashboardSummaryData?.joinedTrendRate,
      clickableItem: { title: 'Replacements', value: dashboardSummaryData?.totalReplaced, onClick: handleOverviewReplacedClick },
      onClick: handleOverviewJoinedClick,
      icon: <ThumbUp />
    },
    {
      title: "Company Goal",
      value: dashboardSummaryData?.goalValue != 0 && dashboardSummaryData?.goalValue,
      secondValue: dashboardSummaryData?.goalValue == 0 && 'Click to Set Goal',
      progressValue: dashboardSummaryData?.goalValue != 0 && goalProgressRounded,
      onClick: handleGoalsClick,
      icon: <Flag />
    },
    {
      title: "Refund Accounts",
      value: dashboardSummaryData?.totalRefundAccounts,
      secondValue: dashboardSummaryData?.totalRefundAccounts > 0 && `Pending: ${dashboardSummaryData?.totalPendingRefunds}`,
      thirdValue: dashboardSummaryData?.totalRefundAccounts > 0 && `Processed: ${dashboardSummaryData?.totalProcessedRefunds}`,
      onClick: handleRefundAccountsClick,
      icon: <CurrencyExchange />
    },
    {
      title: "30 Days Retention",
      value: dashboardManagerSummaryData?.totalJoinedIncludingLeft > 0 ? `${dashboardSummaryData?.thirtyDaysRetention}%` : '--',
      secondValue: `Joined: ${dashboardSummaryData?.totalJoinedIncludingLeft}`,
      thirdValue: `Left: ${dashboardSummaryData?.totalLeftCandidatesWithin30Days}`,
      icon: <Repeat />
    },
  ]

  const appOverviewCardData = [
    {
      title: "Active Employers",
      value: dashboardAppSummaryData?.totalActiveAppClients,
      icon: <Badge />
    },
    {
      title: "Active Jobs",
      value: dashboardAppSummaryData?.totalActiveAppPositions,
      icon: <Work />
    },
    {
      title: "Candidates",
      value: dashboardAppSummaryData?.totalAppCandidates,
      icon: <Person />
    },
    {
      title: "Applications",
      value: dashboardAppSummaryData?.totalJobApplications,
      icon: <Assignment />
    },
    {
      title: "Shortlisted",
      value: dashboardAppSummaryData?.totalShortlisted,
      icon: <Checklist />
    },
    {
      title: "Hired",
      value: dashboardAppSummaryData?.totalHired,
      icon: <ThumbUp />
    },
    {
      title: "Rejected",
      value: dashboardAppSummaryData?.totalRejected,
      icon: <Cancel />
    }
  ]

  return (
    <>
      <HeaderComponent name="Dashboard" />
      <div style={{ marginTop: '12px' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingBottom: '4px' }}>
          <Typography variant='h6' sx={{ fontWeight: 'bold', color: '#3d3d3d', padding: '8px 0', marginLeft: '8px' }}>Overview</Typography>
          <TimePeriodSelector activeItem={dashboardTimePeriod.rangeType} onChange={handleTimePeriodChange} />
        </div>
        <Grid container spacing={3}>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              // justifyContent: 'center',
              flexWrap: 'wrap',
              gap: 2
            }}
          >
            {overviewCardsData.map(card =>
              <SummaryCard
                key={card.title}
                title={card.title}
                value={card.value}
                secondValue={card.secondValue}
                thirdValue={card.thirdValue}
                progressValue={card.progressValue}
                clickableItem={card.clickableItem}
                trendPercentage={card.trendPercentage}
                onClick={card.onClick}
                icon={card.icon}
              />
            )}
          </Box>
        </Grid>
      </div>

      <Box sx={{ width: '100%', marginTop: '16px' }}>
        <Typography variant='h6' sx={{ fontWeight: 'bold', color: '#3d3d3d', padding: '8px 0', marginLeft: '8px' }}>Account Managers</Typography>
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', columnGap: '16px', rowGap: '12px' }}>
          <Card
            sx={{
              width: 250,
              borderRadius: 2,
              boxShadow: 2
            }}
          >
            <CardContent sx={{ padding: '0px !important' }}>
              <div style={{ backgroundColor: cardColors.bgColor, padding: '8px 12px' }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                  }}
                  onClick={() => {
                    handleNavigateToManagerDashboard({
                      adminUserId: 'overall',
                      name: 'Overall'
                    })
                  }}
                >
                  Overall Summary
                </Typography>
                <Typography
                  sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.6)' }}
                >
                  All managers data
                </Typography>
                <Typography
                  sx={{ fontSize: '0.9rem', fontWeight: 'bold', color: cardColors.color }}
                >
                  <span>{dashboardManagerSummaryData?.totalJoined}/{dashboardManagerSummaryData?.totalActiveJobPostsOverall} Hires</span>
                  <span> ({dashboardManagerSummaryData?.conversionRate}%)</span>
                </Typography>
              </div>
              <div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>Active Clients:</span>
                  <span>{dashboardManagerSummaryData?.totalActiveEmployers}</span>
                </div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>Open Positions:</span>
                  <span>{dashboardManagerSummaryData?.totalActiveJobPostsOverall}</span>
                </div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>Goal:</span>
                  <span>{dashboardManagerSummaryData?.goalValue}</span>
                </div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>Selected:</span>
                  <span>{dashboardManagerSummaryData?.totalSelected}</span>
                </div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>Interviewed:</span>
                  <span>{dashboardManagerSummaryData?.totalInterviewed}</span>
                </div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>Candidates Added:</span>
                  <span>{dashboardManagerSummaryData?.totalCandidatesAdded}</span>
                  <span style={{ fontSize: '13px', display: 'flex', alignItems: 'center', marginLeft: '2px', color: 'gray' }}>
                    ({dashboardManagerSummaryData?.totalCVParsed}<DescriptionOutlined style={{ fontSize: '13px' }} />)
                  </span>
                </div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>High Ageing Jobs:</span>
                  <span>{dashboardManagerSummaryData?.totalHighAgeingJobs}</span>
                </div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>Replacement Dues:</span>
                  <span>{dashboardManagerSummaryData?.totalReplacementDues}</span>
                </div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>Zero Lineup Clients:</span>
                  <span>{dashboardManagerSummaryData?.totalZeroLineupEmployers}</span>
                </div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>Positions Worked on:</span>
                  <span>{dashboardManagerSummaryData?.positionsWorkedOn}</span>
                </div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>Clients Worked on:</span>
                  <span>{dashboardManagerSummaryData?.clientsWorkedOn}</span>
                </div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>Contribution:</span>
                  <span>{dashboardManagerSummaryData?.contribution}</span>
                </div>
                <div style={mainStyle.divStyle}>
                  <span style={mainStyle.spanStyle}>30 Days Retention:</span>
                  <span>{dashboardManagerSummaryData?.totalJoinedIncludingLeft > 0 ? `${dashboardManagerSummaryData?.thirtyDaysRetention}%` : '--'}
                    {dashboardManagerSummaryData?.totalJoinedIncludingLeft > 0 &&
                      <LightTooltip placement="top" title={
                        <div>
                          <div><strong>Joined:</strong> {dashboardManagerSummaryData?.totalJoinedIncludingLeft}</div>
                          <div><strong>Left:</strong> {dashboardManagerSummaryData?.totalLeftCandidatesWithin30Days}</div>
                        </div>
                      }>
                        <IconButton size='small'>
                          <Info fontSize='14px' />
                        </IconButton>
                      </LightTooltip>
                    }
                  </span>
                </div>
              </div>
            </CardContent>
          </Card>
          {accountManagers.map((manager, i) => (
            <Card
              key={manager.adminUserId}
              sx={{
                width: 250,
                borderRadius: 2,
                boxShadow: 2
              }}
            >
              <CardContent sx={{ padding: '0px !important' }}>
                <div style={{ backgroundColor: cardColors.bgColor, padding: '8px 12px' }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      '&:hover': {
                        textDecoration: 'underline',
                      },
                    }}
                    onClick={() => { handleNavigateToManagerDashboard(manager) }}
                  >
                    {manager.name}
                  </Typography>
                  <Typography
                    sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.6)' }}
                  >
                    {manager.mobileNumber}
                  </Typography>
                  <Typography
                    sx={{ fontSize: '0.9rem', fontWeight: 'bold', color: cardColors.color }}
                  >
                    <span style={{ textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={() => handleJoinedClick(manager)}
                    >{manager.managerSummary.totalJoined}/{manager.managerSummary.totalActiveJobPostsOverall} Hires</span>
                    <span> ({manager.managerSummary.conversionRate}%)</span>
                  </Typography>
                </div>
                <div>
                  <div style={mainStyle.divStyle}>
                    <span
                      style={{ ...mainStyle.spanStyle, textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={() => handleEmployersClick(manager)}
                    >Active Clients:</span>
                    <span>{manager.managerSummary.totalActiveEmployers}</span>
                  </div>
                  <div style={mainStyle.divStyle}>
                    <span
                      style={{ ...mainStyle.spanStyle, textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={() => handleJobPostsClick(manager)}
                    >Open Positions:</span>
                    <span>{manager.managerSummary.totalActiveJobPostsOverall}</span>
                  </div>
                  <div style={mainStyle.divStyle}>
                    <span style={mainStyle.spanStyle}>Goal:</span>
                    <span>{manager.managerSummary.goalValue != 0 ? manager.managerSummary.goalValue : '--'}</span>
                  </div>
                  <div style={mainStyle.divStyle}>
                    <span style={mainStyle.spanStyle}>Selected:</span>
                    <span>{manager.managerSummary.totalSelected}</span>
                  </div>
                  <div style={mainStyle.divStyle}>
                    <span style={mainStyle.spanStyle}>Interviewed:</span>
                    <span>{manager.managerSummary.totalInterviewed}</span>
                  </div>
                  <div style={mainStyle.divStyle}>
                    <span style={mainStyle.spanStyle}>Candidates Added:</span>
                    <span>{manager.managerSummary.totalCandidatesAdded}</span>
                    <span style={{ fontSize: '13px', display: 'flex', alignItems: 'center', marginLeft: '2px', color: 'gray' }}>
                      ({manager.managerSummary.totalCVParsed}<DescriptionOutlined style={{ fontSize: '13px' }} />)
                    </span>
                  </div>
                  <div style={mainStyle.divStyle}>
                    <span style={{ ...mainStyle.spanStyle, textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={() => handleHighAgeingJobPostsClick(manager)}
                    >High Ageing Jobs:</span>
                    <span>{manager.managerSummary.totalHighAgeingJobs}</span>
                  </div>
                  <div style={mainStyle.divStyle}>
                    <span style={{ ...mainStyle.spanStyle, textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={() => handleReplacementDuesClick(manager)}
                    >Replacement Dues:</span>
                    <span>{manager.managerSummary.totalReplacementDues}</span>
                  </div>
                  <div style={mainStyle.divStyle}>
                    <span style={{ ...mainStyle.spanStyle, textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={() => handleZeroLineupClientClick(manager)}
                    >Zero Lineup Clients:</span>
                    <span>{manager.managerSummary.totalZeroLineupEmployers}</span>
                  </div>
                  <div style={mainStyle.divStyle}>
                    <span style={mainStyle.spanStyle}>Positions Worked on:</span>
                    <span>{manager.managerSummary.positionsWorkedOn}</span>
                  </div>
                  <div style={mainStyle.divStyle}>
                    <span style={mainStyle.spanStyle}>Clients Worked on:</span>
                    <span>{manager.managerSummary.clientsWorkedOn}</span>
                  </div>
                  <div style={mainStyle.divStyle}>
                    <span style={mainStyle.spanStyle}>Contribution:</span>
                    <span>{manager.managerSummary.contribution}</span>
                  </div>
                  <div style={mainStyle.divStyle}>
                    <span style={mainStyle.spanStyle}>30 Days Retention:</span>
                    <span>{manager.managerSummary.totalJoinedIncludingLeft > 0 ? `${manager.managerSummary.thirtyDaysRetention}%` : '--'}
                      {manager.managerSummary.totalJoinedIncludingLeft > 0 &&
                        <LightTooltip placement="top" title={
                          <div>
                            <div><strong>Joined:</strong> {manager.managerSummary.totalJoinedIncludingLeft}</div>
                            <div><strong>Left:</strong> {manager.managerSummary.totalLeftCandidatesWithin30Days}</div>
                          </div>
                        }>
                          <IconButton size='small'>
                            <Info fontSize='14px' />
                          </IconButton>
                        </LightTooltip>
                      }
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </Box>

      <Grid container spacing={2} style={{ marginTop: '16px' }}>
        <Grid size={4}>
          <Paper elevation={2}>
            <MonthlyTrendsChart
              monthlyTrendsData={dashboardMonthlyTrendsData}
            />
          </Paper>
        </Grid>
        <Grid size={8}>
          <Grid container spacing={2}>
            <Grid size={6}>
              <Paper elevation={2}>
                <PendingJoiningDetails
                  pendingCandidates={dashboardPendingDetailsCandidates}
                />
              </Paper>
            </Grid>
            <Grid size={6}>
              <Paper elevation={2}>
                <StickyNotesComponent height={'298px'} />
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <div style={{ marginTop: '12px' }}>
        <Typography variant='h6' sx={{ fontWeight: 'bold', color: '#3d3d3d', padding: '8px 0', marginLeft: '8px' }}>Mobile App Overview</Typography>
        <Grid container spacing={3}>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: 2
            }}
          >
            {appOverviewCardData.map(card =>
              <SummaryCard
                key={card.title}
                title={card.title}
                value={card.value}
                icon={card.icon}
              />
            )}
          </Box>
        </Grid>
      </div>

      {isGoalModalVisible &&
        <GoalModal
          open={true}
          onClose={handleCloseGoalModal}
        />
      }
    </>
  );
};

export default ViewDashboard;

const styles = {
  textBold: {
    fontWeight: 'bold'
  }
}